import React from 'react'
import GrillaComprobantes from '../../moleculas/GrillaComprobantes/GrillaComprobantes'

export default function ComprobantesContainer() {
    return (
        <div>
            <GrillaComprobantes />
        </div>
    )
}


